const seoConfig = {
  "/": {
    title: "India's Top Leading Hospital & Healthcare Management Software Company- ITDOSE INFOSYSTEMS",
    description:
      "ITDOSE INFOSYSTEMS offers medical billing emr and Hospital management software in India. Streamline your workflows with our advanced healthcare ERP and integrated EMR software.",
  },

  "/hospital-information-and-management-system": {
    title: "Best HIMS Software | Hospital Information Management Software System",
    description:
      "Optimize and digitized your patient data with our comprehensive his hospital information system.ITDOSE INFOSYSTEMS offers best health information system & hospital management software.",
  },

  "/laboratory-information-and-management-system": {
    title: "Laboratory Information Management System (LIS) | ITDOSE Infosystems",
    description:
      "ITDOSE INFOSYSTEMS offers LIMS system software to manage lab data, samples & reporting. Our laboratory information management system software ensures diagnostic accuracy for modern labs.",
  },
};

export default seoConfig;
